<script setup lang="ts">
import { ref, defineEmits } from "vue";
import { useNotificationsStore } from "~/stores/UserNotifications";
import ModalDelete from "./ModalDelete.vue";
import ModalCancel from "./ModalCancel.vue";
import ModalReport from "./ModalReport.vue";

const emit = defineEmits(["close"]);
const props = defineProps<{
	id: string;
}>();

const userNotificationStore = useNotificationsStore();

const isModalDeleteOpen = ref(false);
const isModalCancelOpen = ref(false);
const isModalReportOpen = ref(false);

function openModalDelete() {
	isModalDeleteOpen.value = true;
}
function openModalCancel() {
	isModalCancelOpen.value = true;
}
function openModalReport() {
	isModalReportOpen.value = true;
}

const deleteNotification = async () => {
	const id = props.id;
	await userNotificationStore.removeNotification(id as string);
	isModalDeleteOpen.value = false;
	emit("close");
};
</script>

<template>
	<div class="notification">
		<div class="notification--container">
			<a class="notification--container--options" @click="openModalDelete">
				<MGIcon icon="trash" />
				<p>{{ $t("notification_component.delete") }}</p>
			</a>

			<!-- <a class="notification--container--options" @click="openModalCancel">
				<MGIcon icon="cancel-notification" />
				<p>{{ $t("notification_component.cancel") }}</p>
			</a> -->

			<!-- <a class="notification--container--options" @click="openModalReport">
				<MGIcon icon="report" />
				<p>{{ $t("notification_component.report") }}</p>
			</a> -->
		</div>

		<ModalDelete :is-modal-open="isModalDeleteOpen" @close="isModalDeleteOpen = false"
			@delete="deleteNotification" />

		<ModalCancel :is-modal-cancel-open="isModalCancelOpen" @close="isModalCancelOpen = false" />

		<ModalReport :is-modal-report-open="isModalReportOpen" @close="isModalReportOpen = false" />
	</div>
</template>

<style lang="scss" scoped>
.notification {
	background: var(--card-article-bg);
	z-index: 10;
	border: 1px solid var(--card-article-border);

	[dir="rtl"] & {
		right: auto;
		left: 10px;
	}
	width: 100%;
	max-width: 312px;
	display: flex;
	right: 10px;
	flex-direction: column;
	flex: 1;
	position: absolute;

	&--header {
		color: var(--title-fg);
		font-size: 14px;
	}

	&--container {
		display: flex;
		flex-direction: column;

		>a {
			padding: 16px;
		}

		&--options {
			cursor: pointer;
			display: flex;
			background: none;
			border: none;
			align-items: center;

			i {
				width: 24px;
				color: var(--active);
			}

			p {
				color: var(--active);
				margin: 0;
				font-size: 16px;
				font-style: normal;
				font-weight: 400;
				line-height: 24px;
			}

			&:hover {
				background: var(--bg-title);
			}
		}
	}
}
</style>
